import { IWorkNote } from "../../../../types/types";

const plainText = (html: string | null | undefined) =>
  (html || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .toLowerCase();

/** Pinned notes first, then newest first; filtered by title/text. */
export const visibleWorkNotes = (
  notes: IWorkNote[] | undefined,
  search: string,
) => {
  const query = search.trim().toLowerCase();
  return [...(notes ?? [])]
    .filter(
      (note) =>
        !query ||
        (note.title || "").toLowerCase().includes(query) ||
        plainText(note.note).includes(query),
    )
    .sort(
      (a, b) =>
        Number(!!b.isPinned) - Number(!!a.isPinned) ||
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    );
};
